import { AutocompleteValue } from "./api/contracts/AutoComplete";
import { createURIPRovider } from "../templates/common/URIProvider";

const allUUIDVersionsPattern = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i;
export const isUUID = (text: string) => allUUIDVersionsPattern.test(text);
export const getItemUriByItemType = (item: Partial<AutocompleteValue>): string => {
  switch (item.itemType.clazz) {
    case "ConnectionItemType":
      return `/connections/${item.id}`;
    case "InputItemType":
      return `/inputs/view/${item.id}/content`;
    case "IndexItemType":
    case "OutputItemType":
      return createURIPRovider({
        clazz: item.itemType.clazz.replace("ItemType", "Template"),
        id: item.id,
      }).view();
    case "EnvironmentItemType":
      return `/environments/view/${item.id}`;
    case "PermissionsGroupItemType":
      return `/iam/groups/view/${item.id}`;
    case "PermissionsPolicyItemType":
      return `/iam/policies/view/${item.id}`;
    case "UserItemType":
      return `/iam/users/view/${item.id}`;
    default:
      throw new Error(`Can't route for item type: ${JSON.stringify(item.itemType)} and id: ${item.id}`);
  }
};
export const highlightKey = (x: AutocompleteValue) => x.id + x.itemType.clazz;
